import axios from "axios";
import { API_URL } from "@/config";

export default {
  namespaced: true,

  actions: {
    async getMany(_, criteria) {
      const response = await axios.get(`${API_URL}/portionSizes`, { params: criteria });

      if (!response.data || typeof response.data !== "object") {
        throw new Error("Error occurred while processing your request.");
      }

      return response.data;
    },

    async getOne(_, portionSizeId) {
      const response = await axios.get(`${API_URL}/portionSizes/${portionSizeId}`);

      if (!response.data || typeof response.data !== "object") {
        throw new Error("Error occurred while processing your request.");
      }

      return response.data;
    },

    async create(_, portionSizeData) {
      const response = await axios.post(`${API_URL}/portionSizes`, portionSizeData);

      if (response.status !== 201 || !response.data || typeof response.data.id !== "number") {
        throw new Error("Error occurred while processing your request.");
      }

      return response.data;
    },

    async update(_, { portionSizeId, portionSizeData }) {
      const response = await axios.put(`${API_URL}/portionSizes/${portionSizeId}`, portionSizeData);

      if (response.status !== 200 || !response.data) {
        throw new Error("Error occurred while processing your request.");
      }

      return response.data;
    },

    async delete(_, portionSizeId) {
      const response = await axios.delete(`${API_URL}/portionSizes/${portionSizeId}`);

      if (response.status !== 200 || !response.data || !response.data.status) {
        throw new Error("Error occurred while processing your request.");
      }

      return true;
    },

    async markAsDefault(_, portionSizeId) {
      const response = await axios.post(`${API_URL}/portionSizes/${portionSizeId}/markAsDefault`);

      if (
        response.status !== 200 ||
        typeof response.data.id !== "number" ||
        !response.data.default
      ) {
        throw new Error("Error occurred while processing your request.");
      }

      return response.data;
    },

    async getOptions(_, criteria = {}) {
      const response = await axios.get(`${API_URL}/portionSizes/options`, {
        params: criteria,
      });

      if (!response.data || typeof response.data !== "object") {
        throw new Error("Error occurred while processing your request.");
      }

      return response.data;
    },
  },
};
